export interface CatalogOption {
  code: string;
  label: string;
}

// ── Sección 4.1 CD 513 — Agente o elemento material del accidente ──
export const AGENT_CATEGORIES: CatalogOption[] = [
  { code: 'maquinas', label: 'Máquinas' },
  { code: 'transporte', label: 'Medios de transporte y manutención' },
  { code: 'herramientas', label: 'Herramientas manuales y mecanizadas' },
  { code: 'electrico', label: 'Elementos bajo tensión eléctrica' },
  { code: 'sustancias', label: 'Materiales, sustancias y radiaciones' },
  { code: 'ambiente', label: 'Ambiente de trabajo' },
  { code: 'animales', label: 'Animales' },
  { code: 'armas', label: 'Armas' },
  { code: 'superficies', label: 'Superficies de trabajo' },
];

export const AGENT_PART: CatalogOption[] = [
  { code: 'transmision_energia', label: 'Sistema de transmisión de energía' },
  { code: 'mandos_control', label: 'Mandos o control' },
  { code: 'util_trabajo', label: 'Útil de trabajo' },
  { code: 'bancada_cuerpo', label: 'Bancada/cuerpo de la máquina' },
  { code: 'otros', label: 'Otros' },
];

// ── Sección 4.2 CD 513 — Fuente o actividad durante el accidente ──
export const CONTACT_SOURCE: CatalogOption[] = [
  { code: 'operacion_maquinaria', label: 'Operación de maquinaria' },
  { code: 'operacion_herramienta', label: 'Operación de herramienta o equipo manual' },
  { code: 'armaduria_montaje', label: 'Trabajos de armaduría o montaje' },
  { code: 'revision_mantenimiento', label: 'Trabajos de revisión, mantenimiento y reparación' },
  { code: 'transito_domicilio_trabajo', label: 'Tránsito del domicilio al trabajo' },
  { code: 'transito_trabajo_domicilio', label: 'Tránsito del trabajo al domicilio' },
  { code: 'comision_servicio', label: 'Comisión/misión de servicios' },
  { code: 'trabajos_oficina', label: 'Trabajos de oficina' },
  { code: 'trabajos_supervision', label: 'Trabajos de supervisión' },
  { code: 'trabajos_vigilancia', label: 'Trabajos de vigilancia' },
  { code: 'otros', label: 'Otros' },
];

// ── Sección 4.3 CD 513 — Tipo de contacto ──
export const CONTACT_TYPE: CatalogOption[] = [
  { code: 'golpeado_tropezado', label: 'Golpeado contra - Tropezado con' },
  { code: 'golpeado_chocado', label: 'Golpeado contra - Chocado con' },
  { code: 'golpeado_por_objeto', label: 'Golpeado por objetos en movimiento' },
  { code: 'caida_distinto_nivel', label: 'Caída a distinto nivel' },
  { code: 'caida_resbalon', label: 'Caída a mismo nivel - Resbalón y caída' },
  { code: 'caida_volcarse', label: 'Caída a mismo nivel - Volcarse' },
  { code: 'atrapado_compresion', label: 'Atrapado - Puntos de compresión' },
  { code: 'atrapado_apriete', label: 'Atrapado - Puntos de apriete' },
  { code: 'cogido_agarrado', label: 'Cogido en - Agarrado entre' },
  { code: 'cogido_colgado', label: 'Cogido en - Colgado de' },
  { code: 'cogido_entre', label: 'Cogido entre' },
  { code: 'contacto_electricidad', label: 'Contacto con electricidad' },
  { code: 'contacto_calor', label: 'Contacto con calor' },
  { code: 'contacto_frio', label: 'Contacto con frío' },
  { code: 'contacto_radiaciones', label: 'Contacto con radiaciones' },
  { code: 'contacto_causticos', label: 'Contacto con productos cáusticos' },
  { code: 'contacto_toxicos', label: 'Contacto con productos tóxicos' },
  { code: 'exposicion_ruido_explosion', label: 'Exposición a ruido y explosiones' },
  { code: 'sobreesfuerzo_fisico', label: 'Sobretensión - Sobreesfuerzo físico' },
  { code: 'sobreesfuerzo_trabajo', label: 'Sobretensión - Sobreesfuerzo de trabajo' },
  { code: 'sobreesfuerzo_mental', label: 'Sobretensión - Sobreesfuerzo mental' },
  { code: 'otros', label: 'Otros' },
];

// ── Sección 5.1.1 CD 513 — Condiciones subestándar (causas directas) ──
export const SUBSTANDARD_CONDITIONS: CatalogOption[] = [
  { code: 'proteccion_inexistente', label: 'Protecciones y resguardos inexistentes o no adecuados' },
  { code: 'epi_inexistente', label: 'Equipos de protección individual (EPI) inexistentes o no adecuados' },
  { code: 'equipo_defectuoso', label: 'Máquinas, equipos, herramientas o materiales defectuosos' },
  { code: 'espacio_limitado', label: 'Espacio limitado para desenvolverse' },
  { code: 'senalizacion_insuficiente', label: 'Sistemas de advertencia insuficientes' },
  { code: 'peligro_explosion_incendio', label: 'Peligro de explosión o incendio' },
  { code: 'orden_limpieza_deficiente', label: 'Orden y limpieza deficientes en el lugar de trabajo' },
  { code: 'exposicion_agentes_biologicos', label: 'Exposición a agentes biológicos' },
  { code: 'exposicion_agentes_quimicos', label: 'Exposición a agentes químicos: gases, vapores, polvos, humos y nieblas' },
  { code: 'exposicion_ruido_vibracion', label: 'Exposiciones a ruido y/o vibración' },
  { code: 'exposicion_radiaciones', label: 'Exposiciones a radiaciones ionizantes y no ionizantes' },
  { code: 'exposicion_temperaturas', label: 'Exposición a temperaturas altas o bajas' },
  { code: 'iluminacion_deficiente', label: 'Iluminación excesiva o deficiente' },
  { code: 'ventilacion_insuficiente', label: 'Ventilación insuficiente' },
  { code: 'presiones_anormales', label: 'Presiones anormales' },
  { code: 'condiciones_no_ergonomicas', label: 'Condiciones no ergonómicas' },
  { code: 'otros', label: 'Otros' },
];

// ── Sección 5.1.2 CD 513 — Acciones subestándar (causas directas) ──
export const SUBSTANDARD_ACTIONS: CatalogOption[] = [
  { code: 'operar_sin_autorizacion', label: 'Operar equipos sin autorización' },
  { code: 'no_senalar_peligro', label: 'No señalar o advertir el peligro' },
  { code: 'falla_asegurar', label: 'Falla en asegurar adecuadamente' },
  { code: 'velocidad_inadecuada', label: 'Operar a velocidad inadecuada con equipos, máquinas, otros' },
  { code: 'eliminar_dispositivos_seguridad', label: 'Poner fuera de servicio o eliminar dispositivos de seguridad' },
  { code: 'usar_equipo_defectuoso', label: 'Usar equipo defectuoso o inadecuado' },
  { code: 'uso_incorrecto_equipo', label: 'Usar los equipos y/o herramientas de manera incorrecta' },
  { code: 'no_usar_epp', label: 'Emplear en forma inadecuada o no usar el equipo de protección personal' },
  { code: 'colocar_carga_incorrecta', label: 'Colocar la carga de manera incorrecta' },
  { code: 'almacenar_incorrecto', label: 'Almacenar de manera incorrecta' },
  { code: 'manipular_carga_incorrecta', label: 'Manipular cargas en forma incorrecta' },
  { code: 'levantar_equipos_incorrecto', label: 'Levantar equipos en forma incorrecta' },
  { code: 'posicion_inadecuada', label: 'Adoptar una posición inadecuada para hacer la tarea' },
  { code: 'mantenimiento_en_operacion', label: 'Realizar mantenimiento con los equipos operando' },
  { code: 'bromas_pesadas', label: 'Hacer bromas pesadas' },
  { code: 'alcohol_drogas', label: 'Trabajar bajo la influencia del alcohol y/u otras drogas' },
  { code: 'falta_coordinacion', label: 'Falta de coordinación en operaciones conjuntas' },
  { code: 'otros', label: 'Otros' },
];

// ── Sección 5.2.1 CD 513 — Factores de trabajo (causas indirectas) ──
export const WORK_FACTORS: CatalogOption[] = [
  { code: 'supervision_liderazgo', label: 'Supervisión y liderazgo deficitarios' },
  { code: 'diseno_ingenieria', label: 'Diseño de ingeniería no adecuado al proceso' },
  { code: 'deficiencia_adquisiciones', label: 'Deficiencia en las adquisiciones' },
  { code: 'mantenimiento_deficiente', label: 'Mantenimiento deficiente' },
  { code: 'herramientas_no_adecuadas', label: 'Herramientas y equipos no adecuados' },
  { code: 'estandares_deficientes', label: 'Estándares deficientes de trabajo' },
  { code: 'uso_desgaste_equipos', label: 'Uso y desgaste de equipos, máquinas, herramientas' },
];

// ── Sección 5.2.2 CD 513 — Factores del trabajador (causas indirectas) ──
export const WORKER_FACTORS: CatalogOption[] = [
  { code: 'capacidad_anatomica_limitada', label: 'Reducción o limitación de la capacidad anatómica-fisiológica' },
  { code: 'aptitudes_reducidas', label: 'Reducción o limitación de aptitudes cognitivas, motrices o sensoriales' },
  { code: 'actitudes_reducidas', label: 'Reducción o limitación de las actitudes (falta de motivación, riesgo sicosocial)' },
  { code: 'tension_fisica', label: 'Tensión física o fisiológica (fatiga, lesión, ingestión de drogas)' },
  { code: 'tension_mental', label: 'Tensión mental o psicológica (estrés, acoso, falta de conocimiento)' },
];

// ── Sección 5.3 CD 513 — Causas básicas (6 ítems fijos) ──
// Mapean 1:1 a columnas boolean en incident_investigations
export const BASIC_CAUSES: { field: string; label: string }[] = [
  { field: 'basic_cause_hazard_id', label: 'Identificación de peligros; medición, evaluación y control de riesgos' },
  { field: 'basic_cause_env_surveillance', label: 'Vigilancia ambiental laboral y de la salud' },
  { field: 'basic_cause_prior_investigation', label: 'Investigación de accidentes y enfermedades profesionales u ocupacionales' },
  { field: 'basic_cause_ppe', label: 'Equipos de protección individual y ropa de trabajo' },
  { field: 'basic_cause_training', label: 'Formación, capacitación y adiestramiento de los trabajadores' },
  { field: 'basic_cause_operational_control', label: 'Control operativo integral' },
];

export function requiresCd513Investigation(
  severity: 'leve' | 'grave' | 'muy_grave' | 'mortal',
  daysLost: number
): boolean {
  return (
    severity === 'muy_grave' ||
    severity === 'mortal' ||
    (severity === 'grave' && daysLost > 365)
  );
}
